// extracted by mini-css-extract-plugin
export default {"body":"invoiceRequestedModal_body__9eJod"};